import React, { CSSProperties } from 'react';
import Alert from '@material-ui/lab/Alert/Alert';
import { isFailedState, isLoadingState } from 'globals/utils';
import { LoadingState } from 'globals/types';
import defaultLocales from 'globals/locales/default';

import FsLoader from '../FsLoader';

// Locales
const { defaultFallbackComponentInfo } = defaultLocales;

interface FsDefaultFallbackComponentProps {
  status: LoadingState;
  style?: CSSProperties;
  withShadow?: boolean;
  withMargin?: boolean;
}

const FsDefaultFallbackComponent: React.FC<FsDefaultFallbackComponentProps> = ({
  status,
  style,
  withShadow,
  withMargin,
}) => {
  if (isLoadingState(status))
    return (
      <FsLoader style={style} withShadow={withShadow} withMargin={withMargin} />
    );
  if (isFailedState(status))
    return (
      <Alert severity="error" style={style}>
        {defaultFallbackComponentInfo}
      </Alert>
    );
  return null;
};

export default FsDefaultFallbackComponent;
